import { Component, Input, OnInit, inject, effect, computed } from '@angular/core';
import { AppService } from '../../../app/app.service';
import { PhitoSession } from '../../../services/phito-session';
import { UserChangeDialogComponent } from '../../administration/usergroup/user-change-dialog/user-change-dialog.component';
import { PhitoUserDTO } from '../../../services/phito-object';
import { MatDialog } from '@angular/material/dialog';
import { PhitoSessionService } from '../../../services/phito-session.service';
import { UserProfilePictureService } from '../../../services/user-profile-picture.service';
import { LoginService } from '../../login/login.service';
import { RadioFieldOption } from '../../../components/phito-form/radio-field/radio-field-model';
import { DialogService } from '../../../services/dialog.service';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { PermissionAction } from '../../administration/role-and-permissions/role-and-permission';
import { RouterService } from '../../../services/router.service';
import { USER_ROUTES } from '../../administration/administration.routes';
import { PhitoFormDialogResult } from '../../../components/phito-form/phito-form-dialog/phito-form-dialog';
import { HelpFeaturesDialogComponent } from '../help-features-dialog/help-features-dialog.component';
import { HelpFeaturesDialogInput } from '../help-features-dialog/help-features-dialog';

@Component({
    selector: 'phito-profile-button',
    templateUrl: './profile-button.component.html',
    styleUrls: ['./profile-button.component.css'],
    imports: [MatButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem],
})
export class ProfileButtonComponent implements OnInit {
    protected appService = inject(AppService);
    private routerService = inject(RouterService);
    private dialog = inject(MatDialog);
    protected phitoSessionService = inject(PhitoSessionService);
    private profilePictureService = inject(UserProfilePictureService);
    private loginService = inject(LoginService);
    private dialogService = inject<DialogService<PhitoSession>>(DialogService);

    representative: PhitoUserDTO;
    @Input() options: any;
    hasUserGroupViewPermission = false;

    thumbnailUrl: string | null = null;

    initials = computed(() => {
        const user = this.phitoSessionService.phitoSession().user;
        const fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim();
        if (!fullName) {
            return '';
        }
        const parts = fullName.split(/\s+/).filter(Boolean);
        return parts
            .slice(0, 2)
            .map((part) => part.charAt(0).toUpperCase())
            .join('');
    });

    inSeveralCompanies = computed(() => this.phitoSessionService.phitoSession()?.user?.companySettings?.length > 1);
    user = computed(() => this.phitoSessionService.phitoSession()?.user)
    userHexId = computed(() => this.user()?.id)

    constructor() {
        effect(() => {
            this.profilePictureService
                .loadProfilePicture(this.userHexId())
                .subscribe((thumbnail) => {
                    this.thumbnailUrl = thumbnail;
                });
        });
    }

    ngOnInit(): void {
        this.representative = this.phitoSessionService.getRepresentative();
        this.hasUserGroupViewPermission = this.phitoSessionService.hasPermission(
            new PermissionAction('Administration', 'Benutzer', 'Meine Benutzergruppen ansehen'),
            'ProfileButtonComponent',
        );
    }

    logout() {
        this.loginService.logout(true);
    }

    openProfileSettings() {
        this.routerService.nav(USER_ROUTES.userSettings);
    }

    openHelpFeaturesDialog() {
        const input = new HelpFeaturesDialogInput();
        this.dialog.open(HelpFeaturesDialogComponent, {
            data: input,
            width: '640px',
            maxWidth: '90vw',
        });
    }

    changeUser() {
        this.dialog
            .open(UserChangeDialogComponent, { width: '50%' })
            .afterClosed()
            .subscribe((userDto: PhitoUserDTO) => {
                if (userDto) {
                    this.phitoSessionService.setRepresentative(userDto);
                    location.reload();
                }
            });
    }

    refresh() {
        this.phitoSessionService.sessionAktualisieren(true);
    }

    // getWorktimeInPercent() {
    //   const hundredPercentInSeconds = 28800;
    //   const alreadyWorkedInPercent = this.currentWorkDay?.worktime / (hundredPercentInSeconds / 100);
    //   this.alreadyWorkedInPercent = alreadyWorkedInPercent + '%';
    // }
    //
    // getWorkToDoInPercent() {
    //   const hundredPercentInSeconds = 8 * 60 * 60;
    //   const workToDoInSeconds = hundredPercentInSeconds - this.currentWorkDay?.worktime;
    //   this.workToDoInPercent = workToDoInSeconds / (hundredPercentInSeconds / 100) + '%';
    // }

    changeCompany() {
        const options: RadioFieldOption[] = [];
        for (const c of this.user()?.companySettings) {
            if (!(c.company?.id === this.phitoSessionService.phitoSession()?.company?.id)) {
                const o = new RadioFieldOption(c.company.name, c.company);
                options.push(o);
            }
        }
        if (options.length == 1) {
            const txt = 'Wechseln zu "' + options[0].optionTxt + '".';
            this.dialogService.confirm('Mandant wechseln?', txt).subscribe({
                next: (result: PhitoFormDialogResult) => {
                    if (result?.isConfirmed()) {
                        this.loginService.changeCompany(options[0].value);
                    }
                },
            });
        } else {
            this.dialogService.chooseRadioOption('Mandant wechseln', 'Mandant', options).subscribe({
                next: (result) => {
                    if (result?.isConfirmed()) {
                        this.loginService.changeCompany(result?.getEntity().value);
                    }
                },
            });
        }
    }
}
